(() => {
  const loader = document.getElementById('FlowbamPageLoader');
  if (!loader) return;

  const threshold = 220;
  const startedAt = Number(window.__flowbamPageLoaderStartedAt) || performance.now();
  let timerId;
  let isShown = false;
  let isResolved = false;

  const hideImmediately = () => {
    window.clearTimeout(timerId);
    loader.classList.remove('is-visible', 'is-leaving');
    loader.hidden = true;
    loader.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('aria-busy');
  };

  const finish = () => {
    if (isResolved) return;
    isResolved = true;
    window.clearTimeout(timerId);
    document.documentElement.removeAttribute('aria-busy');

    if (!isShown) {
      hideImmediately();
      return;
    }

    loader.classList.remove('is-visible');
    loader.classList.add('is-leaving');
    window.setTimeout(hideImmediately, 180);
  };

  const show = () => {
    if (isResolved || document.readyState !== 'loading') {
      finish();
      return;
    }

    isShown = true;
    loader.hidden = false;
    loader.removeAttribute('aria-hidden');
    document.documentElement.setAttribute('aria-busy', 'true');
    window.requestAnimationFrame(() => loader.classList.add('is-visible'));
  };

  if (window.Shopify && window.Shopify.designMode) {
    hideImmediately();
    return;
  }

  const remaining = Math.max(0, threshold - (performance.now() - startedAt));
  timerId = window.setTimeout(show, remaining);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', finish, { once: true });
  } else {
    finish();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) hideImmediately();
  });
})();
